import MaskedInputService from 'services/maskedInput'
import ownerDataValidator from 'validators/ownerDataValidator'
import { MdNavigateNext } from 'react-icons/md'
import { Formik } from 'formik'

import {
  Form,
  Row,
  Button,
  SubTitle,
  FormField,
  WarningText,
  Input,
  MaskedInput
} from '../styles'

export default function OwnerDataForm ({
  companyData = {},
  onFormSubmitted: handleFormSubmitted = () => null
}) {
  return (
    <Formik
      validationSchema={ownerDataValidator}
      initialValues={{
        'owner': companyData.owner,
        'owner_email': companyData.owner_email,
        'owner_phone': companyData.owner_phone
      }}
      onSubmit={values => handleFormSubmitted (values)}
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        handleChange,
        handleBlur,
        handleSubmit
      }) => (
        <Form onSubmit={handleSubmit} style={{ width: 400 }}>
          <SubTitle>Dados do responsável</SubTitle>
          <Row>
            <FormField>
              <Input
                placeholder='Nome completo do responsável'
                value={values.owner}
                onChange={handleChange ('owner')}
                onBlur={handleBlur ('owner')}
              />
              {touched.owner && errors.owner && (
                <WarningText>{errors.owner}</WarningText>
              )}
            </FormField>
          </Row>
          <Row>
            <FormField>
              <Input
                type='email'
                placeholder='E-mail do responsável'
                value={values.owner_email}
                onChange={handleChange ('owner_email')}
                onBlur={handleBlur ('owner_email')}
              />
              {touched.owner_email && errors.owner_email && (
                <WarningText>{errors.owner_email}</WarningText>
              )}
            </FormField>
          </Row>
          <Row>
            <FormField>
              <MaskedInput
                name='owner_phone'
                placeholder='Celular do responsável'
                options={{
                  blocks: [0, 2, 5, 4],
                  delimiters: ['(', ') ', '-'],
                  numericOnly: true
                }}
                value={values.owner_phone}
                onChange={event => MaskedInputService.handleChange (event, setFieldValue)}
                onBlur={handleBlur ('owner_phone')}
              />
              {touched.owner_phone && errors.owner_phone && (
                <WarningText>{errors.owner_phone}</WarningText>
              )}
            </FormField>
          </Row>
          <Button type='submit'>
            <MdNavigateNext size={30}/>
          </Button>
        </Form>
      )}
    </Formik>
  )
}
